import { LocalStorage } from "@swiggy-private/core-ui";
import { DineCashPoolingIntentRecord } from "@dineout-cart-client/interfaces";
import { DINE_CASH_POLLING_LOCAL_STORAGE_KEY } from "@dineout-cart-client/constants/DineCashPoolingIntent";
import { format, isEmpty, isString } from "@swiggy-private/js-utils";

export function readDineCashPoolingIntent(): DineCashPoolingIntentRecord | null {
    const parsedIntentData = LocalStorage.getItem<DineCashPoolingIntentRecord>(DINE_CASH_POLLING_LOCAL_STORAGE_KEY);
    if (!isEmpty(parsedIntentData) && isString(parsedIntentData.cartId) && isString(parsedIntentData.userId)) {
        return parsedIntentData;
    }
    return null;
}

export function persistDineCashPoolingIntent(cartId: string, userId: string): void {
    if (!cartId || !userId) {
        return;
    }
    LocalStorage.setItem(DINE_CASH_POLLING_LOCAL_STORAGE_KEY, { cartId, userId });
}

export function clearDineCashPoolingIntent(): void {
    LocalStorage.removeItem(DINE_CASH_POLLING_LOCAL_STORAGE_KEY);
}

const DINE_CASH_WHATSAPP_MESSAGE =
    "Hi, I'm settling the bill on Swiggy Dineout. Chip in your DineCash and we all save more. 💸\n\nTap here to send:\n{0}";

export function getDineCashWhatsAppMessage(shareLink: string): string {
    return format(DINE_CASH_WHATSAPP_MESSAGE, shareLink);
}
